import React from 'react';

import useRoles from 'core/hooks/useRoles';
import { Role as RoleType } from 'core/types/role';

type Props = {
  id: RoleType['id'];
};

export default function Role({ id }: Props) {
  const role = useRoles().find(role => role.id === id);

  return <>{role ? role.label : id}</>;
}
